export class PriceAttributeModel {
    public priceAttributeId: string;
    public parentPriceAttributeId: string;
    public attributeTypeCode: string;
    public attributeChoiceId: string;
    public attributeValue: number;
    public conditionCode: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}